import {
  type FieldValues,
  type FormItemWrapperProps,
  type Path,
  type PathValue,
  type UseControllerProps,
  useCustomController,
} from '@faceup/form'
import { FormItem, SurveyRate } from '@faceup/ui'

type Option = {
  label: string
  value: string
}

type UiSelectProps<T> = {
  options: T[]
}

type SurveyRateChoiceProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<UiSelectProps<Option> & FormItemWrapperProps, 'value' | 'defaultValue'>

export const SurveyRateChoice = <T extends FieldValues>(props: SurveyRateChoiceProps<T>) => {
  const {
    formItemProps,
    inputProps: { onChange },
  } = useCustomController({ ...props, defaultValue: undefined as PathValue<T, Path<T>> })

  const selectOption = (starCount: number) => {
    if (starCount === 0) {
      onChange(undefined)
      return
    }

    const option = props.options.find(option => option.label === String(starCount))
    if (!option) {
      console.warn(`No option found for value: ${starCount}`)
      return
    }

    onChange(option.value)
  }

  const { options } = props

  return (
    <FormItem {...formItemProps}>
      <SurveyRate onChange={selectOption} count={options.length} />
    </FormItem>
  )
}
